// Form validation for Client Site form
import { plaintextValidator, dropdownValidator } from '../fields';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  timezoneCode: plaintextValidator(config)
};
